import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useCallback } from 'react';

import {
    VerifyHeaderContainer,
    VerifyPageWrapperStyled,
    VerifyWrapperStyled,
} from './styled/VerifyStyled';
import { MainHeader } from '../../components/main-header/MainHeader';
import { Header2Styled, ParagraphStyled } from '../../components/typography/styled/TypographyStyled';
import ProfileButton from "../Account/components/ProfileButton/ProfileButton";
import { RouterPaths } from "../../app/appConstants";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import BackButton from "../../components/BackButton/BackButton.jsx";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";
import VerifyContent from "./VerifyContent";

const Verify = () => {
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', true);
    const {getLangPath} = useLangContext();
    const {handleGTMClick} = useGTMEvent();

    const verificationEmail = getLangPath('verify.email');
    const pageDescriptionHtml = getLangPath('verify.text_html', {email: verificationEmail});

    const handleTradeClick = useCallback(() => handleGTMClick({module: 'Header', button: 'Trade'}), [handleGTMClick]);

    return (
            <>
                <MainHeader>
                    <Button variant="outline-primary" size="sm" as={Link} to={RouterPaths.trade}
                            onClick={handleTradeClick}>
                        {getLangPath('verify.trade')}
                    </Button>
                    <ProfileButton className="ms-2 ms-sm-3"/>
                </MainHeader>
                <VerifyPageWrapperStyled>
                    <VerifyWrapperStyled>
                        <BackButton/>
                        <VerifyHeaderContainer>
                            <Header2Styled>{getLangPath('verify.title')}</Header2Styled>
                            <ParagraphStyled className="mt-3" dangerouslySetInnerHTML={{__html: pageDescriptionHtml}}/>
                        </VerifyHeaderContainer>
                        <VerifyContent/>
                    </VerifyWrapperStyled>
                </VerifyPageWrapperStyled>
            </>
    );
};

export default Verify;